<template>
  <v-container fluid class="pt-0 px-0">
    <reporting-hub-app-bar></reporting-hub-app-bar>
    <v-container v-if="report && filter" class="pa-0">
      <template v-if="report.typeUrl == 'culture'">
        <pulse-heatmap
          v-if="report.url == 'heatmap'"
          :filter="filter"
        ></pulse-heatmap>
        <pulse-heatmap
          v-else-if="report.url == 'high-low'"
          :filter="filter"
          hide-progress
          title="High & Low Heatmap"
          expand-on-load
        ></pulse-heatmap>
        <pulse-feedback v-else-if="report.url == 'feedback'"></pulse-feedback>
        <pulse-report
          v-else
          :filter="filter"
          :team="team"
          :manager="manager"
        ></pulse-report>
      </template>
      <participation-report
        v-if="report.typeUrl == 'participation'"
        :title="report.name"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      ></participation-report>
      <usage-report
        v-if="report.url == 'features' && report.typeUrl == 'usage'"
        :filter="filter"
      ></usage-report>
      <recognition-report
        v-if="report.url == 'activity' && report.typeUrl == 'recognition'"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      ></recognition-report>
      <goal-report
        v-if="report.url == 'tracking' && report.typeUrl == 'goals'"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      ></goal-report>
      <template v-if="report.typeUrl == '360-reviews'">
        <review-heatmap
          v-if="report.url == 'heatmap'"
          :filter="filter"
        ></review-heatmap>
        <review-report
          v-else
          :filter="filter"
          :team="team"
          :manager="manager"
          :user="user"
        ></review-report>
      </template>
      <overall-score-report
        v-if="report.url == 'score' && report.typeUrl == 'overall'"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      ></overall-score-report>
      <manager-score-report
        v-if="report.url == 'managerscore' && report.typeUrl == 'overall'"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      ></manager-score-report>
      <core-board-report
        v-if="report.url == 'coreboard' && report.typeUrl == 'overall'"
      ></core-board-report>
      <v-container
        v-if="report.url == 'overview' && report.typeUrl == 'annual-reviews'"
      >
        <annual-review-overview-table></annual-review-overview-table>
      </v-container>
      <survey-report-overview
        v-if="report.url == 'overview' && report.typeUrl == 'surveys'"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      >
      </survey-report-overview>
      <resource-report-overview
        v-if="report.url == 'overview' && report.typeUrl == 'training'"
        :filter="filter"
        :team="team"
        :manager="manager"
        :user="user"
      >
      </resource-report-overview>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import reports from "@/helpers/mixins/reports";
import PulseHeatmap from "@/components/pulse/PulseHeatmap";
import PulseReport from "@/components/reporting/PulseReport";
import ParticipationReport from "@/components/reporting/ParticipationReport";
import PulseFeedback from "@/components/pulse/PulseFeedback";
import UsageReport from "@/components/reporting/UsageReport";
import RecognitionReport from "@/components/reporting/RecognitionReport";
import GoalReport from "@/components/reporting/GoalReport";
import ReportingHubAppBar from "@/components/reporting/ReportingHubAppBar";
import ReviewReport from "@/components/reporting/ReviewReport";
import ReviewHeatmap from "@/components/reviews/ReviewHeatmap";
import OverallScoreReport from "@/components/reporting/OverallScoreReport";
import ManagerScoreReport from "@/components/reporting/ManagerScoreReport";
import AnnualReviewOverviewTable from "@/components/annualreviews/AnnualReviewOverviewTable";
import SurveyReportOverview from "@/components/reporting/SurveyReportOverview";
import ResourceReportOverview from "@/components/reporting/ResourceReportOverview";
import CoreBoardReport from "@/components/reporting/CoreBoardReport";
import { getReportingCompany } from "@/helpers/local";
export default {
  name: "ReportingDetails",
  components: {
    PulseHeatmap,
    PulseReport,
    ParticipationReport,
    PulseFeedback,
    UsageReport,
    RecognitionReport,
    GoalReport,
    ReportingHubAppBar,
    ReviewReport,
    ReviewHeatmap,
    OverallScoreReport,
    ManagerScoreReport,
    AnnualReviewOverviewTable,
    SurveyReportOverview,
    ResourceReportOverview,
    CoreBoardReport
  },
  mixins: [reports],
  data: () => ({
    loading: false,
    filter: null
  }),
  watch: {
    profile(val, oldVal) {
      if (val != oldVal) {
        this.update();
      }
    },
    settings(val, oldVal) {
      if (val != oldVal) {
        this.update();
      }
    },
    report(val, oldVal) {
      if (val != oldVal) {
        this.update();
      }
    }
  },
  computed: {
    coreCardTypeId() {
      if (this.report) {
        if (this.report.typeUrl == "culture") {
          switch (this.report.url) {
            case "mission-value":
              return this.$enums.coreCardTypes.MISSION_VALUE;
            case "team-cohesion":
              return this.$enums.coreCardTypes.TEAM_COHESION;
            case "strategic-anchors":
              return this.$enums.coreCardTypes.STRATEGIC_ANCHORS;
            case "score":
              return this.$enums.coreCardTypes.PULSE;
            case "enps":
              return this.$enums.coreCardTypes.ENPS;
          }
        } else if (
          this.report.url == "score" &&
          this.report.typeUrl == "overall"
        ) {
          return this.$enums.coreCardTypes.OVERALL;
        } else if (this.report.typeUrl == "360-reviews") {
          switch (this.report.url) {
            case "ideal-team-player":
              return this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER;
            case "score":
              return this.$enums.coreCardTypes.REVIEW;
          }
        }
      }
      return 0;
    },
    featureId() {
      if (this.report) {
        if (this.report.typeUrl == "participation") {
          switch (this.report.url) {
            case "culture":
              return this.$enums.features.PULSE;
            case "surveys":
              return this.$enums.features.SURVEYS;
            case "training":
              return this.$enums.features.RESOURCE;
            case "360-reviews":
              return this.$enums.features.REVIEW;
          }
        }
      }
      return null;
    },
    report() {
      return this.reports.find(
        x =>
          this.$route.params.parentId == x.typeUrl &&
          this.$route.params.reportId == x.url
      );
    },
    team() {
      return this.teams.find(x => x.id == this.filter.teamId);
    },
    manager() {
      let item = this.users.find(x => x.id == this.filter.managerId);
      if (item) {
        return item;
      }
      if (this.profile.id == this.filter.managerId) {
        return this.profile;
      }
      return null;
    },
    user() {
      let item = this.users.find(x => x.id == this.filter.userId);
      if (item) {
        return item;
      }
      if (this.profile.id == this.filter.userId) {
        return this.profile;
      }
      return null;
    },
    reportingCustomerId() {
      return this.$auth.isSuperAdmin() || this.$auth.isCoreCoach()
        ? getReportingCompany()
        : null;
    },
    settings() {
      return this.$store.getters[
        this.reportingCustomerId
          ? "customer/customer_settings"
          : "profile/settings"
      ];
    },
    ...mapGetters({
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager",
      profile: "profile/profile",
      teams: "reporting/teams",
      users: "reporting/users",
      timeframe: "reporting/timeframe",
      reports: "reporting/reports"
    })
  },
  created() {
    this.update();
  },
  methods: {
    update() {
      if (this._.isEmpty(this.profile) || this._.isEmpty(this.settings)) {
        return;
      }

      let callArray = [this.$store.dispatch("reporting/getReports")];

      if (this.is_admin || this.profile.isManager) {
        callArray = callArray.concat([
          this.$store.dispatch("company/getBusinessMetrics"),
          this.$store.dispatch("reporting/getTrendTypes"),
          this.$store.dispatch("reporting/getTeams"),
          this.$store.dispatch("reporting/getUsers")
        ]);
      }

      this.loading = true;
      Promise.all(callArray)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading this page."
          );
        })
        .finally(() => {
          this.loading = false;
        });

      let managerId =
        this.$route.params.type == "teams" ? this.$route.params.typeId : null;
      let userId =
        this.$route.params.type == "members" ? this.$route.params.typeId : null;
      if (!this.is_admin) {
        if (this.profile.isManager) {
          if (!managerId && !userId) {
            managerId = this.profile.id;
          }
        } else {
          if (!userId) {
            userId = this.profile.id;
          }
        }
      }

      this.filter = {
        featureId: this.featureId,
        coreCardTypeId: this.coreCardTypeId,
        teamId:
          this.$route.params.type == "departments"
            ? this.$route.params.typeId
            : null,
        managerId: managerId,
        userId: userId,
        timeframeId:
          this.timeframe.timeframeId ||
          (this.report &&
          this.report.url == "overview" &&
          this.report.typeUrl == "training"
            ? this.$enums.timeframes.ALL_TIME
            : this.$enums.timeframes.LAST_90_DAYS),
        customStartDate: this.timeframe.customStartDate,
        customEndDate: this.timeframe.customEndDate,
        customTimezone: this.timeframe.customTimezone,
        categoryId: this.$route.params.categoryId,
        questionId: this.$route.params.questionId,
        instanceIds: this.$route.params.surveyInstanceId
          ? [this.$route.params.surveyInstanceId]
          : this.$route.params.resourceScheduleId
          ? [this.$route.params.resourceScheduleId]
          : null,
        resourceId: this.$route.params.resourceId,
        surveyId: this.$route.params.surveyId,
        breakdownId: "department",
        trendIds: [null]
      };

      if (
        this.report &&
        this.report.url == "high-low" &&
        this.report.typeUrl == "culture"
      ) {
        this.filter.highLow = true;
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar__extension {
  background-color: white !important;
}
</style>
